import React, { useState, useEffect } from 'react';


//^MUI imports + CSS
import { CssBaseline, useMediaQuery } from '@mui/material';

import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import './App.css'

import axios from 'axios';

import Navbar from './components/Navbar/Navbar'


//^used in router
import AdminRoutes from './components/Routes/AdminRoutes';
import PrivateRoutes from './components/Routes/PrivateRoutes';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';


//^404 page used in router
import Error404 from './components/ErrorPages/Error404';

//^simple loader
import ClipLoader from "react-spinners/ClipLoader";


//^Redux & RTK imports
import { useAddCartMutation,  useAddFavoriteMutation,  useAddPopularProductMutation,  useGetAllPopularProductsQuery,  useGetCartQuery, useGetUserFavoritesQuery } from './features/fullApi';
import { addToCart } from './features/slices/cartSlice';
import { useDispatch, useSelector } from "react-redux"
import { addToFavorite } from './features/slices/favoriteSlice';


//^Products pages CRUD
import CreateSmartphone from './components/ProductsPages/Smartphones/Smartphone/CreateSmartphone';
import EditSmartphone from './components/ProductsPages/Smartphones/Smartphone/EditSmartphone';
import GetSmartphone from './components/ProductsPages/Smartphones/Smartphone/GetSmartphone';
import Smartphones from './components/ProductsPages/Smartphones/Smartphones'

import CreateHeadphone from './components/ProductsPages/Headphones/Headphone/CreateHeadphone';
import EditHeadphone from './components/ProductsPages/Headphones/Headphone/EditHeadphone';
import GetHeadphone from './components/ProductsPages/Headphones/Headphone/GetHeadphone';
import Headphones from './components/ProductsPages/Headphones/Headphones';


import CreateCharger from './components/ProductsPages/Chargers/Charger/CreateCharger';
import EditCharger from './components/ProductsPages/Chargers/Charger/EditCharger';
import GetCharger from './components/ProductsPages/Chargers/Charger/GetCharger';
import Chargers from './components/ProductsPages/Chargers/Chargers';

import CreateCase from './components/ProductsPages/Phonecases/Phonecase/CreatePhonecase';
import EditCase from './components/ProductsPages/Phonecases/Phonecase/EditPhonecase';
import GetPhonecase from './components/ProductsPages/Phonecases/Phonecase/GetPhonecase';
import Phonecases from './components/ProductsPages/Phonecases/Phonecases';

import Homepage from './components/Homepage/Homepage';
import Footer from './components/Footer/Footer';
import Contact from './components/Contact/Contact';


//^Other pages
import Cart from './components/Cart/Cart'
import Favorite from './components/Favorite/Favorite'
import Checkout from './components/Checkout/Checkout'
import Users from './components/User/Users';
import EditUser from './components/User/EditUser';
import AddressForm from './components/Checkout/AddressForm';
import Orders from './components/Checkout/Orders';
import Order from './components/Checkout/Order';
import UserOrders from './components/Checkout/UserOrders';
import OrderDetails from './components/Checkout/OrderDetails';


//^Recommendation System
import aa from 'search-insights';


//^Authentication and Authorization
import LoginForm from './components/Authentication/LoginForm';
import RegisterForm from './components/Authentication/RegisterForm';
import VerifiedEmail from './components/Authentication/VerifiedEmail';
import Emailsent from './components/Authentication/Emailsent';
import ForgotPassword from './components/Authentication/ForgotPassword';
import ResetPassword from './components/Authentication/ResetPassword';
import EmailVerificationPasswordSent from './components/Authentication/EmailVerificationPasswordSent';
import EmailChanged from './components/Authentication/EmailChanged';


//^Notifications
import { Toaster } from 'react-hot-toast';
import 'react-notifications-component/dist/theme.css'

//^Imported cookie library for setting up GA4 and GTM user tracking
import { useCookies } from 'react-cookie';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';


import ReactGA from "react-ga4";
ReactGA.initialize("G-0WK9RWZWFW");


// initializing search insights
aa('init', {
  appId: "EXZ7Q11Q58",
  apiKey: "812cfff2beb8916035b22c33e01a4c3e",
});

//setting user token
aa('setUserToken', 'user-1');

const App = () => {
  const lightTheme = createTheme({
    typography: {
     "fontFamily": "Poppins",
     "fontSize": 14,
     "fontWeightLight": 300,
     "fontWeightRegular": 400,
     "fontWeightMedium": 500
    },
    palette: {
      primary: {
        main: '#93032E',
      },
      secondary: {
        main: '#FCF6B1',
      },
      text: {
        main: '#fff'
      },
    },
    overrides: {
      MuiButton: {
        raisedPrimary: {
          color: 'white',
        },
      },
    }
 });


 const darkTheme = createTheme({
  typography: {
    "fontFamily": "Arial",
    "fontSize": 14,
    "fontWeightLight": 300,
    "fontWeightRegular": 400,
    "fontWeightMedium": 500
   },
   palette: {
     primary: {
       main: '#121212',
     },
     secondary: {
       main: '#FCF6B1',
     },
     text: {
       main: '#fff'
     },
   },
   overrides: {
    MuiButton: {
      raisedPrimary: {
        color: 'white',
      },
    },
  }
});
  

  const dispatch = useDispatch()
  
  let user = {}
  user = useSelector(state => state.auth.user)
  const [cookies, setCookie] = useCookies(['user']);
  if(!user) {
    user = JSON.parse(localStorage.getItem('user')) || ""
    if(user === "") {

    } else  { 

      setCookie('userId', user._id)
    }
  }

  const [mode, setMode] = useState(JSON.parse(localStorage.getItem('theme')) | "");
  useEffect(() => {
    let currentTheme = ""
    if(JSON.parse(localStorage.getItem('theme'))) {
      currentTheme = JSON.parse(localStorage.getItem('theme'))
    } else {
      currentTheme = "light" ;
    }
    
    setMode(currentTheme)
  }, [])

  const selectedTheme = mode === "dark" ? darkTheme : lightTheme;


  
  const {data: cartData, error: cartError, isLoading: cartIsLoading} = useGetCartQuery(user._id);
  const [addCart] = useAddCartMutation()
  const {data: favoriteData, error:errorFavorite,isLoading:isLoadingFavorite} = useGetUserFavoritesQuery(user._id)
  const [addFavorite] = useAddFavoriteMutation()
  const [executed, setExecuted] = useState(false)


  const [addPopularSmartphone] = useAddPopularProductMutation()

  const {data: popularSmartphoneData, error: popularSmartphoneError, isLoading: isLoadingPopularSmartphone} = useGetAllPopularProductsQuery();

  if(popularSmartphoneData?.length===0 && !isLoadingPopularSmartphone) {
    addPopularSmartphone({smartphones: []})
  }

  if(user && !cartData &&!favoriteData &&!isLoadingFavorite && !executed & !cartIsLoading) {
    setExecuted(true)
    addCart({userId: user._id, items: []}, { 
      headers: {
        'Token': `Bearer ${user?.accessToken}`
      }
    })
    .then(res => {
      
    })
    .catch((e) => {

    })

    addFavorite({userId: user._id, items: []}, { 
      headers: {
        'Token': `Bearer ${user?.accessToken}`
      }
    })
    .then(res => {
      console.log("Res is", res)
    })
    .catch((e) => {
      console.log("e is", e)
    })
  }


  let cartProducts = []
  const getProductData = (product) => {
    console.log("CALLING IT")
    // if(product.category === "products") {
      const data = axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/allItems/find/${product.productId}`)
      .then(res => {
        res.data.cartQuantity = product.quantity
        cartProducts.push(res.data)
        localStorage.setItem("cartItems", JSON.stringify(cartProducts))
        for(let i = product.quantity; i>0; i--) {
          dispatch(addToCart(res.data))
        }
      })
      .catch(e => {})
  }

    useEffect(() => {

        parse()
    }, [cartData])

    const parse = () => {
      cartData?.products.map(async (product) => {
        await getProductData(product)
      })
    }
    

    let favoriteProducts = []
    const getProductsDataFavorite = (product) => {
      const data = axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/allItems/find/${product.productId}`)
      .then(res => {
        favoriteProducts.push(res.data)
        localStorage.setItem("favoriteItems", JSON.stringify(favoriteProducts))
        dispatch(addToFavorite(res.data))
      })
      .catch(e => {})
    }
  
      useEffect(() => {
          parseFavorite()
      }, [favoriteData])
  
      const parseFavorite = () => {
        favoriteData?.products.map(async (product) => {
          await getProductsDataFavorite(product)
        })
      }

    const theme = useTheme()
    const isSm= useMediaQuery(theme.breakpoints.down('sm'));
    const isMd= useMediaQuery(theme.breakpoints.down('md'));
    
  useEffect(() => {
    getAddress()
  }, [])

  const [addressDetails, setAddressDetails] = useState()
  const getAddress = async (details) => {
    console.log("DETAILS", details)
    setAddressDetails(details)
  }

  const currentTheme = JSON.parse(localStorage.getItem('theme'))


  const changeTheme = () => {
    if(mode === 'light') {
      setMode('dark')
      localStorage.setItem("theme", JSON.stringify(mode))
    } else {
      localStorage.setItem("theme", JSON.stringify("light"))
      setMode('light')
      localStorage.setItem("theme", JSON.stringify(mode))
    }
  }


  return (
    <>
    {/* <ReactNotifications /> */}
    {cartIsLoading && !user && !cartError ? (
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 64px)'}}>
          <ClipLoader
            color="#93032E"
            loading={cartIsLoading}
            size={150}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>      
      ) :
    <>
    <ThemeProvider theme={selectedTheme}>
    <Toaster
      position="bottom-center"
      reverseOrder={false}
    />
    <Router>
      <div>
        <CssBaseline /> 
        <Navbar mode={mode} changeTheme={changeTheme}/>
        <div className={isSm ? 'mtMobile' : 'mtDesk'}>
          <Routes>
            {/*ROUTES AVAILABLE FOR GUEST*/}
            <Route exact path="/" element={<Homepage/>}>
            </Route>
            <Route exact path="/privacy" element={<PrivacyPolicy style={{marginTop: 20}}/>}>
            </Route>
            <Route exact path="/chargers/:page?/:filter?" element={<Chargers style={{marginTop: 20}}/>}>
            </Route>
            <Route exact path="/headphones/:page?/:filter?" element={<Headphones style={{marginTop: 20}}/>}>
            </Route>
            <Route exact path="/phonecases/:page?/:filter?" element={<Phonecases style={{marginTop: 20}}/>}>
            </Route>
            <Route exact path="/smartphones/:page?/:filter?" element={<Smartphones style={{marginTop: 20}}/>}>
            </Route>
            <Route exact path="/smartphone/:id" element={<GetSmartphone style={{marginTop: 20}}/>}>
            </Route>
            <Route exact path="/phonecase/:id" element={<GetPhonecase style={{marginTop: 20}}/>}>
            </Route>
            <Route exact path="/charger/:id" element={<GetCharger style={{marginTop: 20}}/>}>
            </Route>
            <Route exact path="/headphone/:id" element={<GetHeadphone style={{marginTop: 20}}/>}>
            </Route>
            <Route exact path="/register" element={<RegisterForm></RegisterForm>}>
            </Route>
            <Route exact path="/login" element={<LoginForm></LoginForm>}>
            </Route>
            <Route path="*" element={<Error404></Error404>}></Route>
            <Route exact path="/verify/:userId/:uniqueString" element={<VerifiedEmail style={{marginTop: 20}}/>}>
            </Route>
            <Route exact path="/emailsent" element={<Emailsent style={{marginTop: 20}}/>}>
            </Route>
            <Route exact path="/resetpasswordemail" element={<EmailVerificationPasswordSent style={{marginTop: 20}}/>}>
            </Route>
            <Route exact path="/forgottenpassword" element={<ForgotPassword></ForgotPassword>}></Route>
            <Route exact path="/resetpassword/:userId/:uniqueString" element={<ResetPassword></ResetPassword>}></Route>

            <Route element={<AdminRoutes/>}>
              <Route exact path="/smartphone/create" element={<CreateSmartphone></CreateSmartphone>}>
              </Route>
              <Route exact path="/smartphone/edit/:id" element={<EditSmartphone></EditSmartphone>}>
              </Route>
              <Route exact path="/charger/create" element={<CreateCharger></CreateCharger>}>
              </Route>
              <Route exact path="/charger/edit/:id" element={<EditCharger></EditCharger>}>
              </Route>
              <Route exact path="/headphone/create" element={<CreateHeadphone></CreateHeadphone>}>
              </Route>
              <Route exact path="/headphone/edit/:id" element={<EditHeadphone></EditHeadphone>}>
              </Route>
              <Route exact path="/orders" element={<Orders></Orders>}>
              </Route>
              <Route exact path="/phonecase/create" element={<CreateCase></CreateCase>}>
              </Route>
              <Route exact path="/phonecase/edit/:id" element={<EditCase></EditCase>}>
              </Route>
              <Route exact path="/users" element={<Users></Users>}></Route>
              <Route exact path="/users/find/:id" element={<EditUser></EditUser>}></Route>
              <Route exact path="/orders/find/:userId" element={<UserOrders></UserOrders>}></Route>
            </Route>
            <Route element={<PrivateRoutes/>}>
                <Route exact path="/cart/find/:userId" element={<Cart/>}></Route>
                <Route exact path="/favorite/find/:userId" element={<Favorite/>}>
                </Route>
                <Route path="/checkout/:userId" exact element={<Checkout addressDetails={addressDetails}/>}>
                </Route>
                <Route exact path="/account/:id/:tab?" element={<EditUser></EditUser>}></Route>
                <Route exact path="/address" element={<AddressForm getAddress={getAddress}></AddressForm>}></Route>
                <Route exact path="/order" element={<Order addressDetails={addressDetails}></Order>}></Route>
                <Route exact path="/order/:id" element={<OrderDetails ></OrderDetails>}></Route>
                <Route exact path="/contact" element={<Contact></Contact>}></Route>
                <Route exact path="/changeEmail/:userId/:uniqueString" element={<EmailChanged></EmailChanged>}></Route>
            </Route>
          </Routes>
          </div>
          <Footer/>
          </div>
    </Router>
    </ThemeProvider>
    </>
    }
    </>
  )
}

export default App